import { render, staticRenderFns } from "./Infothek.vue?vue&type=template&id=0b6bbb6a&"
import script from "./Infothek.vue?vue&type=script&lang=js&"
export * from "./Infothek.vue?vue&type=script&lang=js&"
import style0 from "./Infothek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports